import { alpha } from '@mui/material'

export const useAlertStyles = () => {
    return {
        sx: {
            borderRadius: '12px',
            marginBottom: '0px',
        },
    }
}
